import { render, staticRenderFns } from "./FormQuestionRating5Type.vue?vue&type=template&id=0ea9ec52"
import script from "./FormQuestionRating5Type.vue?vue&type=script&lang=js"
export * from "./FormQuestionRating5Type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea9ec52')) {
      api.createRecord('0ea9ec52', component.options)
    } else {
      api.reload('0ea9ec52', component.options)
    }
    module.hot.accept("./FormQuestionRating5Type.vue?vue&type=template&id=0ea9ec52", function () {
      api.rerender('0ea9ec52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionRating5Type.vue"
export default component.exports